import React, { useState } from 'react';

import GenericModal from '../../../components/agv-generic-modal';
import { MODAL_SIZE, MODAL_SIZE_STYLE } from '../../../enums/modal-size.enum';
import { Banner, CopyField, Toggle } from '../clients-ui';

/**
 * Displays a freshly generated secret (API key, documentation password). This is the only time it
 * exists (one-time reveal): the modal can only be closed (cross, Escape, click outside) once the
 * copy has been confirmed, so that it is not lost by mistake. Mounted only while it is displayed,
 * it starts over without confirmation for each secret. It is rendered by the client sheet, not by the
 * tab that issued the secret, so that changing tab while the request is still in flight cannot lose it.
 *
 * @param {string} title - Title of the modal
 * @param {string} label - Name of the secret, above the field to copy
 * @param {string} secret - The secret in clear text
 * @param {React.ReactNode} warning - Warning displayed at the top
 * @param {React.ReactNode} hint - Usage instructions, below the field
 * @param {string} confirmLabel - Sentence of the "J'ai copié…" checkbox
 */
export default function SecretRevealModal({
  title,
  label,
  secret,
  warning,
  hint,
  confirmLabel,
  onClose,
}) {
  const [isConfirmed, setIsConfirmed] = useState(false);

  return (
    <GenericModal
      isOpen
      setIsOpen={(isOpen) => {
        if (!isOpen && isConfirmed) onClose();
      }}
      title={title}
      size={MODAL_SIZE_STYLE[MODAL_SIZE.XL]}
      mainActionText="Terminer"
      mainAction={onClose}
      mainActionDisabled={!isConfirmed}
    >
      <div className="tw-flex tw-flex-col tw-gap-4">
        <Banner tone="warn">{warning}</Banner>
        <CopyField label={label} value={secret} />
        <p className="tw-m-0 tw-text-[12px] tw-text-[#4a5360]">{hint}</p>
        <Toggle
          checked={isConfirmed}
          onChange={setIsConfirmed}
          label={confirmLabel}
          description="La fenêtre ne peut se fermer qu’après cette confirmation."
        />
      </div>
    </GenericModal>
  );
}
